import { createFileRoute } from '@tanstack/react-router';
import MetadataFieldDefinitionsComponent from 'src/Administration/Metadata/MetadataFieldDefinitions/MetadataFieldDefinitions';

export const Route = createFileRoute('/systemadmin/_layout/metadata/field-definitions')({
  component: MetadataFieldDefinitionsComponent,
});
